module.exports = __webpack_public_path__ + "img/logo_rtr.db86491.png";